import Vue from 'vue'
import router from './router/index.js'
import store from './store/store.js'
import './assets/styles/custom.scss'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
// App must be imported after Bootstrap in order to override styles
import App from './App.vue'
import i18n from './services/i18n'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = true
Vue.config.devtools = true

import responseService from "@/services/responseService";

// and running it somewhere here
responseService()

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  i18n,

  beforeCreate: function (){
    store.commit('SET_PROPERTY_GUID',  this.$route.query.property)
    store.commit('SET_TENANT_AUTH_TOKEN',  this.$route.query.auth)
    store.dispatch("AutoLogin")

    // we are getting a date string and appending it to the theme styles URL to prevent caching of the theme css
    var date = new Date();
    var dateStr = '' + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds();
    let tenantPropertyUri = "/residents/properties/" + store.getters.getPropertyGuid;
      // UPDATE CSS THEME
    let file = document.createElement('link');
    file.rel = 'stylesheet';
    file.href = tenantPropertyUri + "/styles?date=" + dateStr;
    document.head.appendChild(file);

    if(store.getters.getPropertyGuid && store.getters.getPropertyGuid.length > 0) {
      // UPDATE FAVICON
      let faviconLink = document.getElementById('favicon');
      faviconLink.href = tenantPropertyUri + "/files/favicons?date=" + dateStr;
    } else {
      console.log("No Property Guid found, using default favicon.");
    }
  }
})

router.beforeEach((to, from, next) => {
      // redirect to login page if not logged in and trying to access a restricted page
      const publicPages = ['/portal/login', '/portal/unauthorized', '/portal/loggedOut']
      const authRequired = !publicPages.includes(to.path);
      const localJWT = sessionStorage.getItem('jwtToken');

      if (authRequired && !localJWT) {
        return next({name: 'Login'});
      }
      const isPortalAllowed = store.getters.getIsPortalAllowed
      if(isPortalAllowed === false){
          return next({name: 'Login'});
      }
      if (localJWT !== undefined && localJWT !== "") {
        let expireDateString = sessionStorage.getItem("tokenExpirationDate")
        let nowDate = Date.now()
        const authExpireDate = new Date(expireDateString)
        //Allow auto login for 5 minute from when the auth token expired or force the user to log in again.
        let fiveMinGrace = new Date(authExpireDate);
        fiveMinGrace.setMinutes(authExpireDate.getMinutes() + 5);
        if (nowDate >= fiveMinGrace.getTime()) {
            store.commit("SET_LOGGED_OUT")
            return next({name: 'Login'});
        }
      }
      next()
    }
)



